@if(currentRoute == "/") {
    <footer class="white-bg">
        <div class="width-container">
            <div role="button" aria-label="terms and conditions popup" id="footnote1" tabindex="0" class="info-terms" [innerHtml]="'FOOTER.TERMS_TITLE' | translate" (click)="showTerms()" (keydown.enter)="showTerms()"></div>
            <div>
                <a [href]="'CONSENTS.PRIVACY_POLICY_LINK' | translate" tabindex="0" class="fit-content" [attr.aria-label]="'CONSENTS.PRIVACY_POLICY_ARIA' | translate" [innerHtml]="'CONSENTS.PRIVACY_POLICY' | translate" target="_blank"></a>
                <button class="cookie-consent" tabindex="0" [innerHtml]="'CONSENTS.COOKIE_PREFS' | translate"></button>
            </div>
            <p tabindex="-1" id="footnote2" [innerHtml]="'FOOTER.FOOTNOTE2' | translate:data"></p>
            <p [innerHtml]="'FOOTER.DISCLAIMER' | translate:data"></p>
        </div>
    </footer>
} @else if (currentRoute == "/confirmation"){

    <footer class="white-text">
        <div class="width-container">
            <p [innerHtml]="'FOOTER.CONFIRMATION_TEXT' | translate:data"></p>
            <div role="button" aria-label="terms and conditions popup" id="footnote1" tabindex="0" class="info-terms" [innerHtml]="'FOOTER.TERMS_TITLE' | translate" (click)="showTerms()" (keydown.enter)="showTerms()"></div>
            <div>
                <a [href]="'CONSENTS.PRIVACY_POLICY_LINK' | translate" tabindex="0" class="fit-content" [attr.aria-label]="'CONSENTS.PRIVACY_POLICY_ARIA' | translate" [innerHtml]="'CONSENTS.PRIVACY_POLICY' | translate" target="_blank"></a>
                <button class="cookie-consent cookie-consent-white" tabindex="0" [innerHtml]="'CONSENTS.COOKIE_PREFS' | translate"></button>
            </div>
        </div>
    </footer>
}
@else {
    <footer class="white-bg">
        <div class="width-container">
            <div role="button" aria-label="terms and conditions popup" id="footnote1" tabindex="0" class="info-terms" [innerHtml]="'FOOTER.TERMS_TITLE' | translate" (click)="showTerms()" (keydown.enter)="showTerms()"></div>
        </div>
    </footer>
}